import { j as m } from "./atoms-v218.js";
import * as d from "react";
import { useId as u, useRef as h, useContext as a, useInsertionEffect as x } from "react";
import { MotionConfigContext as C } from "./atoms-v2881.js";
class R extends d.Component {
  getSnapshotBeforeUpdate(o) {
    const e = this.props.childRef.current;
    if (e && o.isPresent && !this.props.isPresent) {
      const t = this.props.sizeRef.current;
      t.height = e.offsetHeight || 0, t.width = e.offsetWidth || 0, t.top = e.offsetTop, t.left = e.offsetLeft;
    }
    return null;
  }
  /**
   * Required with getSnapshotBeforeUpdate to stop React complaining.
   */
  componentDidUpdate() {
  }
  render() {
    return this.props.children;
  }
}
function z({ children: i, isPresent: o }) {
  const e = u(), t = h(null), r = h({
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }), { nonce: s } = a(C);
  return x(() => {
    const { width: p, height: f, top: c, left: l } = r.current;
    if (o || !t.current || !p || !f)
      return;
    t.current.dataset.motionPopId = e;
    const n = document.createElement("style");
    return s && (n.nonce = s), document.head.appendChild(n), n.sheet && n.sheet.insertRule(`
          [data-motion-pop-id="${e}"] {
            position: absolute !important;
            width: ${p}px !important;
            height: ${f}px !important;
            top: ${c}px !important;
            left: ${l}px !important;
          }
        `), () => {
      document.head.removeChild(n);
    };
  }, [o]), m.jsx(R, { isPresent: o, childRef: t, sizeRef: r, children: d.cloneElement(i, { ref: t }) });
}
export {
  z as PopChild
};
